import { useState } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { GraduationCap, X } from "lucide-react";

interface Props {
  athleteId: string;
}

export default function RecruitingNudge({ athleteId }: Props) {
  const storageKey = `ll_recruiting_nudge_dismissed_${athleteId}`;
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(storageKey) === "1"
  );

  if (dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(storageKey, "1");
    setDismissed(true);
  };

  return (
    <section className="mb-6">
      <div className="rounded-xl border border-[#415A77]/40 bg-gradient-to-r from-[#0D1B2A] to-[#1B263B] px-4 py-4 flex items-center justify-between gap-4 shadow shadow-black/20">
        <div className="flex items-start gap-3">
          <GraduationCap className="h-6 w-6 text-[#E0A458] flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-white text-sm">Don't wait on recruiting</p>
            <p className="text-xs text-slate-400 mt-0.5">
              Know when coaches can contact you, check core course requirements, and write your first coach email.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link href="/recruiting">
            <Button
              size="sm"
              className="bg-[#E0A458] text-black hover:bg-[#f0b467] font-semibold text-xs whitespace-nowrap"
            >
              Open Recruiting Center
            </Button>
          </Link>
          <button
            type="button"
            aria-label="Dismiss recruiting nudge"
            className="text-slate-500 hover:text-white transition-colors"
            onClick={dismiss}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
